module.exports = __webpack_public_path__ + "static/img/1.ba11324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/pharmacy/3/1.png
// module id = e3sL
// module chunks = 1